import { Castle } from './castle'
import { Chunin } from './HiddenLeaf/chunin'
import { Jacinto } from './Jacinto/jacinto'
import { Mode } from './default'
import { Flume } from './flume'
import { Development } from './Development/development'
import { SomethingInTheTallGrass } from './TallGrass/tall_grass'
import { Normandy } from './Normandy/normandy'

export default {
  Castle,
  Chunin,
  Flume,
  Jacinto,
  Mode,
  Development,
  SomethingInTheTallGrass,
  Normandy,
}